module.exports = __webpack_public_path__ + "da470438f181dd3cb7a5ac0c2c0bd3ed.pdf";